function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200px",
    height: "200px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8294b8",
    d: "M 77.5,1.5 C 88.6544,0.505231 99.9877,0.171898 111.5,0.5C 112.167,1.83333 112.833,3.16667 113.5,4.5C 105.833,4.5 98.1667,4.5 90.5,4.5C 91.0906,3.84851 91.7573,3.18185 92.5,2.5C 87.544,1.50585 82.544,1.17252 77.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aab6cf",
    d: "M 77.5,1.5 C 82.544,1.17252 87.544,1.50585 92.5,2.5C 91.7573,3.18185 91.0906,3.84851 90.5,4.5C 84.1374,4.9204 77.804,5.58706 71.5,6.5C 72.2625,5.73209 73.2625,5.23209 74.5,5C 71.7216,3.60809 68.7216,3.10809 65.5,3.5C 69.2357,2.01086 73.2357,1.3442 77.5,1.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#475f90",
    d: "M 111.5,0.5 C 138.284,1.03999 162.617,8.87332 184.5,24C 191.381,30.0157 196.381,37.1823 199.5,45.5C 199.5,50.5 199.5,55.5 199.5,60.5C 194.975,72.5362 186.975,81.7029 175.5,88C 157.473,97.417 138.473,103.25 118.5,105.5C 105.833,105.5 93.1667,105.5 80.5,105.5C 60.5272,103.25 41.5272,97.417 23.5,88C 12.0251,81.7029 4.02507,72.5362 -0.5,60.5C -0.5,55.5 -0.5,50.5 -0.5,45.5C 1.21113,39.7473 4.21113,34.7473 8.5,30.5C 7.16667,32.5 7.16667,34.5 8.5,36.5C -0.297231,53.9722 3.36944,68.4722 19.5,80C 42.7408,94.8553 68.2408,102.022 96,101.5C 123.401,102.475 149.234,96.6412 173.5,84C 184.273,78.5584 191.44,70.0584 195,58.5C 196.524,46.0432 192.358,35.8766 182.5,28C 161.859,13.5806 138.859,5.74732 113.5,4.5C 112.833,3.16667 112.167,1.83333 111.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#627cbe",
    d: "M 90.5,4.5 C 98.1667,4.5 105.833,4.5 113.5,4.5C 138.859,5.74732 161.859,13.5806 182.5,28C 192.358,35.8766 196.524,46.0432 195,58.5C 191.44,70.0584 184.273,78.5584 173.5,84C 149.234,96.6412 123.401,102.475 96,101.5C 68.2408,102.022 42.7408,94.8553 19.5,80C 3.36944,68.4722 -0.297231,53.9722 8.5,36.5C 12.539,31.46 17.2056,27.1266 22.5,23.5C 28.7414,19.8805 35.0748,16.5472 41.5,13.5C 51.1911,9.93839 61.1911,7.60505 71.5,6.5C 77.804,5.58706 84.1374,4.9204 90.5,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1d7e5",
    d: "M 65.5,3.5 C 68.7216,3.10809 71.7216,3.60809 74.5,5C 73.2625,5.23209 72.2625,5.73209 71.5,6.5C 61.1911,7.60505 51.1911,9.93839 41.5,13.5C 40.596,12.791 40.2627,11.791 40.5,10.5C 43.3462,10.4484 45.6796,9.44836 47.5,7.5C 53.2688,5.22505 59.2688,3.89172 65.5,3.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dadde5",
    d: "M 87.5,13.5 C 91.8333,13.5 96.1667,13.5 100.5,13.5C 100.002,18.1522 99.6686,22.8189 99.5,27.5C 105.21,27.471 110.877,27.971 116.5,29C 121.452,30.7301 124.119,34.2301 124.5,39.5C 122.603,49.1521 120.77,58.8188 119,68.5C 114.263,69.4692 109.43,69.8025 104.5,69.5C 105.692,60.9887 107.026,52.4887 108.5,44C 108.441,42.5643 108.108,41.231 107.5,40C 103.577,39.2073 99.7436,39.374 96,40.5C 94.3799,50.2226 92.5466,59.8892 90.5,69.5C 85.8333,69.5 81.1667,69.5 76.5,69.5C 76.6321,66.1105 76.7988,62.7772 77,59.5C 68.5399,68.7488 58.0399,72.0821 45.5,69.5C 44.9797,74.129 43.9797,78.629 42.5,83C 37.8452,83.4992 33.1785,83.6658 28.5,83.5C 31.4891,65.0794 34.9891,46.7461 39,28.5C 47.755,27.3503 56.5883,27.1837 65.5,28C 72.697,28.6698 77.8637,32.1698 81,38.5C 82.9818,30.0802 85.1485,21.7469 87.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2aec8",
    d: "M 47.5,7.5 C 45.6796,9.44836 43.3462,10.4484 40.5,10.5C 40.2627,11.791 40.596,12.791 41.5,13.5C 35.0748,16.5472 28.7414,19.8805 22.5,23.5C 21.9033,23.2648 21.5699,22.7648 21.5,22C 21.9783,20.6974 22.645,19.5307 23.5,18.5C 30.7116,13.3092 38.7116,9.64255 47.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0f1013",
    d: "M 87.5,15.5 C 91.5546,15.1758 95.5546,15.5091 99.5,16.5C 98.1168,20.7499 97.1168,25.0832 96.5,29.5C 103.23,29.2264 109.897,29.7264 116.5,31C 122.169,33.8151 124.002,38.3151 122,44.5C 120.048,52.4273 118.548,60.4273 117.5,68.5C 113.833,68.5 110.167,68.5 106.5,68.5C 108.515,58.9285 109.682,49.2619 110,39.5C 104.928,38.5286 99.7616,38.1953 94.5,38.5C 92.832,48.5039 91.1654,58.5039 89.5,68.5C 85.4454,68.8242 81.4454,68.4909 77.5,67.5C 81.4762,50.2858 84.8095,32.9525 87.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7689b0",
    d: "M 23.5,18.5 C 22.645,19.5307 21.9783,20.6974 21.5,22C 21.5699,22.7648 21.9033,23.2648 22.5,23.5C 17.2056,27.1266 12.539,31.46 8.5,36.5C 7.16667,34.5 7.16667,32.5 8.5,30.5C 12.5789,25.3007 17.5789,21.3007 23.5,18.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#333437",
    d: "M 67.5,30.5 C 58.5,30.5 49.5,30.5 40.5,30.5C 40.7373,31.791 40.404,32.791 39.5,33.5C 39.5,32.1667 39.5,30.8333 39.5,29.5C 49.015,29.1731 58.3483,29.5064 67.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d0e11",
    d: "M 67.5,30.5 C 78.2345,32.9495 82.0678,39.6161 79,50.5C 76.4322,60.0663 70.2655,65.8996 60.5,68C 54.8431,68.4994 49.1764,68.6661 43.5,68.5C 42.704,73.147 42.0373,77.8137 41.5,82.5C 37.8333,82.5 34.1667,82.5 30.5,82.5C 33.286,66.1375 36.286,49.8042 39.5,33.5C 40.404,32.791 40.7373,31.791 40.5,30.5C 49.5,30.5 58.5,30.5 67.5,30.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3e5ed",
    d: "M 129.5,27.5 C 138.173,27.3336 146.84,27.5002 155.5,28C 167.658,30.1546 172.825,37.3212 171,49.5C 168.573,59.5925 162.406,66.0925 152.5,69C 146.833,69.3333 141.167,69.6667 135.5,70C 134.556,74.1509 133.556,78.3176 132.5,82.5C 127.88,83.4933 123.214,83.8266 118.5,83.5C 121.599,65.5013 124.766,47.5013 128,29.5C 128.717,28.9558 129.217,28.2891 129.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0e0f12",
    d: "M 131.5,81.5 C 127.351,82.0803 123.684,81.4136 120.5,79.5C 123.244,62.7801 126.244,46.1135 129.5,29.5C 139.912,29.0738 150.246,29.5738 160.5,31C 166.77,33.535 169.77,38.2017 169.5,45C 168.824,57.3586 162.49,65.0253 150.5,68C 144.804,68.1701 139.138,68.6701 133.5,69.5C 132.555,73.448 131.888,77.448 131.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e8f90",
    d: "M 61.5,38.5 C 57.3998,38.2367 53.3998,38.5701 49.5,39.5C 51.0478,38.2057 53.0478,37.5391 55.5,37.5C 57.6965,37.5046 59.6965,37.838 61.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e2e4e9",
    d: "M 61.5,38.5 C 67.0759,38.9736 69.2426,41.9736 68,47.5C 67.3282,54.6698 63.4949,58.6698 56.5,59.5C 52.6707,60.069 49.3373,59.4023 46.5,57.5C 47.5007,51.4945 48.5007,45.4945 49.5,39.5C 53.3998,38.5701 57.3998,38.2367 61.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#647ebf",
    d: "M 51.5,39.5 C 66.7162,37.5323 70.3829,43.0323 62.5,56C 57.6725,58.3699 52.6725,58.8699 47.5,57.5C 48.8413,51.4714 50.1746,45.4714 51.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5d6da",
    d: "M 139.5,37.5 C 157.066,35.2018 161.733,41.7018 153.5,57C 147.892,60.0427 141.892,61.2094 135.5,60.5C 136.677,52.7965 138.01,45.1298 139.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#637ebf",
    d: "M 140.5,39.5 C 145.267,39.1908 149.934,39.6908 154.5,41C 156.967,54.3707 151.3,60.204 137.5,58.5C 138.779,52.216 139.779,45.8826 140.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#757678",
    d: "M 46.5,57.5 C 49.3373,59.4023 52.6707,60.069 56.5,59.5C 53.0381,60.4816 49.3714,60.815 45.5,60.5C 45.2627,59.209 45.596,58.209 46.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#444548",
    d: "M 120.5,79.5 C 123.684,81.4136 127.351,82.0803 131.5,81.5C 127.702,82.4834 123.702,82.8168 119.5,82.5C 119.263,81.209 119.596,80.209 120.5,79.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhpLogo);
export default __webpack_public_path__ + "static/media/php_logo.bdc53c89ed5c53436af1acbc8c8f7704.svg";
export { ForwardRef as ReactComponent };